import type { PlanningRecordRepository, PlanningScope } from "@/data/repositories/planningRecordRepository";

const PREFIX = "atelier-suite:planning:";

function key(scope: PlanningScope) {
  return `${PREFIX}${scope.organizationId}:${scope.eventId ?? "organization"}:${scope.module}`;
}

export class DummyPlanningRecordRepository implements PlanningRecordRepository {
  async list<T extends { id: string }>(scope: PlanningScope, seed: T[] = []): Promise<T[]> {
    const raw = localStorage.getItem(key(scope));
    if (raw) return JSON.parse(raw) as T[];
    localStorage.setItem(key(scope), JSON.stringify(seed));
    return seed;
  }

  async save<T extends { id: string }>(scope: PlanningScope, value: T): Promise<void> {
    const items = await this.list<T>(scope);
    const index = items.findIndex((item) => item.id === value.id);
    if (index === -1) items.push(value);
    else items[index] = value;
    localStorage.setItem(key(scope), JSON.stringify(items));
  }

  async remove(scope: PlanningScope, id: string): Promise<void> {
    const items = await this.list(scope);
    localStorage.setItem(key(scope), JSON.stringify(items.filter((item) => item.id !== id)));
  }
}
